<template>
  <div>
    <small class="">
      <a :class="upvoteColor" href="#" @click.prevent="upvoteToggle">
        <svg
          viewBox="0 5 24 24"
          width="15"
          height="20"
          stroke="currentColor"
          stroke-width="2"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="css-i6dzq1"
        >
          <path
            d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
          ></path>
        </svg>
      </a>
    </small>
    <small class="me-2">{{ summary }}</small>
    <small class="me-2">
      <a :class="downvoteColor" href="#" @click.prevent="downvoteToggle">
        <svg
          viewBox="0 0 24 24"
          width="15"
          height="15"
          stroke="currentColor"
          stroke-width="2"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="css-i6dzq1"
        >
          <path
            d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
          ></path>
        </svg>
      </a>
    </small>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['votable'],
  data() {
    return {
      currentVote: _.get(this, 'votable.votes.0', 0),
    }
  },
  computed: {
    parent() {
      return _.get(this, 'votable.type', null)
    },
    upvoteColor() {
      if (this.currentVoteValue === 1) {
        return 'text-success'
      }
      return 'text-dark'
    },
    downvoteColor() {
      if (this.currentVoteValue === -1) {
        return 'text-danger'
      }
      return 'text-dark'
    },
    currentVoteValue() {
      return _.get(this, 'currentVote.value', 0)
    },
    voted() {
      return _.has(this, 'votable.votes.0')
    },
    myVote() {
      return 0
    },
    summary() {
      return _.get(this, 'votable.up_votes_count', 0)
    },
  },
  methods: {
    changeVote(value) {
      let count = _.get(this, `votable.up_votes_count`, 0)
      this.$set(this.votable, 'up_votes_count', count + value)
    },
    upvoteToggle() {
      this.vote(1)
        .then(({ data }) => {
          this.currentVote = data
          if (data.value === 0) {
            this.changeVote(-1)
          } else if (data.value === 1) {
            this.changeVote(1)
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    downvoteToggle() {
      this.vote(-1)
        .then(({ data }) => {
          let oldVote = _.get(this, 'currentVote', { value: 0 })
          this.currentVote = data
          if (oldVote.value === 1) {
            this.changeVote(-1)
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    vote(value) {
      return this.$api.votes.store({
        value,
        type: _.get(this, 'votable.type'),
        id: _.get(this, 'votable.id'),
      })
    },
  },
}
</script>
